<template>
    <div class="account-agreements" :class="{loading: loading}">
        <fieldset>
            <legend>
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Account Agreements
                    </div>

                    <div class="col-sm-6 col-md-5 form-group align-sm-left">
                        <button type="button" class="btn btn-success" @click="() => project.isMultiSignature ? null : open(null)" :disabled="project.isMultiSignature || loading">
                            Create Agreement
                        </button>
                    </div>
                </div>
            </legend>

            <div class="form-group text-right">
                <div class="checkbox">
                    <label>
                        <input v-model.boolean="archived"
                               type="checkbox"
                               id="archived"
                               name="archived">
                        Show Archived
                    </label>
                </div>
            </div>

            <div class="list-group">
                <a href="javascript://void(0)" class="list-group-item"
                   :class="{'list-group-item-success active':selectedModelId === model.id}"
                   v-for="model in models"
                   :key="model.id"
                   @click="open(model.id)">
                    <h4 class="list-group-item-heading">
                        {{model.displayEnrolledVia}} Agreement
                        <span v-if="model.archivedLabel" v-html="model.archivedLabel"></span>
                    </h4>

                    <h6>
                        {{model.created_at | date}} <span v-html="emailNotificationIcon( model )"></span>
                    </h6>
                </a>
            </div>
        </fieldset>

        <account-agreement ref="accountAgreementComponent"
                           :account-id="accountId"
                           :accountable="accountable"
                           :project="project"
                           :model-id="selectedModelId"
                           @afterSave="afterSave">
            <span></span>
        </account-agreement>
    </div>
</template>

<script>
    import models from "./mixins/models";
    import AccountAgreement from "./AccountAgreement";

    export default {
        components: { AccountAgreement },
        mixins: [ models ],

        props: {
            accountId: {
                type: String,
                required: true
            },

            accountable: {
                required: true,
                type: Object
            },

            project: {
                required: true,
                type: Object
            },
        },

        computed: {
            url(){
                return '/api/accountAgreements?_load[]=emailNotifications&account_id=' + this.accountId;
            },

            modelComponent(){
                return 'accountAgreementComponent';
            },

            resourceKey(){
                return 'AccountAgreements';
            },
        },

        methods: {
            emailNotificationIcon( accountAgreement ){
                let errorEmailNotification = _.find( accountAgreement.emailNotifications, ( emailNotification ) => {
                    return emailNotification.error_at !== null;
                } );

                let sentEmailNotification = _.find( accountAgreement.emailNotifications, ( emailNotification ) => {
                    return emailNotification.sent_at !== null;
                } );

                if( !_.isEmpty( accountAgreement.emailNotifications ) ){
                    if( !errorEmailNotification && !sentEmailNotification ){
                        return '<i class="fa fa-bell-o text-grey" aria-hidden="true"></i>';
                    }
                    else {
                        let result = '';

                        if( errorEmailNotification ){
                            result += '<i class="fa fa-bell-slash text-red" aria-hidden="true"></i>&nbsp;';
                        }

                        if( sentEmailNotification ){
                            result += '<i class="fa fa-bell text-green" aria-hidden="true"></i>';
                        }

                        return result;
                    }

                }

                return null;
            }
        },

        watch: {
            archived(){
                this.load();
            }
        },
    }
</script>
